import React from 'react';
import { Activity, AlertTriangle, Database, Globe2, Info, MapPin, Radio } from 'lucide-react';

const Header = ({ lastUpdatedLabel, signalCount, countryCount, recentCount, isSnapshotStale, onOpenAbout }) => {
  return (
    <header className="outbreak-header absolute left-0 right-0 top-0 z-30 flex items-center justify-between gap-4 px-5 py-3">
      <div className="flex min-w-0 items-center gap-4">
        <a href="/" className="group flex min-w-0 items-center gap-2.5">
          <div className="relative flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-cyan-300/20 bg-cyan-400/15 shadow-[0_0_24px_rgba(34,211,238,0.24)]">
            <Globe2 className="h-5 w-5 text-white" strokeWidth={2.4} />
          </div>
          <div className="min-w-0 leading-none">
            <div className="text-[15px] font-semibold tracking-tight text-cyan-50">OutbreakMap</div>
            <div className="mt-0.5 truncate text-[10.5px] uppercase tracking-[0.18em] text-cyan-500/90">Global signal radar</div>
          </div>
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          <a href="/" className="flex items-center gap-1.5 rounded-md bg-cyan-400/10 px-3 py-1.5 text-[12px] font-medium text-cyan-100">
            <MapPin className="h-3.5 w-3.5" /> Map
          </a>
          <a href="/about" className="rounded-md px-3 py-1.5 text-[12px] text-cyan-200/70 transition-colors hover:bg-cyan-500/5 hover:text-cyan-100">
            Methodology
          </a>
          <a href="/faq" className="rounded-md px-3 py-1.5 text-[12px] text-cyan-200/70 transition-colors hover:bg-cyan-500/5 hover:text-cyan-100">
            FAQ
          </a>
        </nav>
      </div>

      <div className="flex shrink-0 items-center gap-3">
        <div className={`hidden items-center gap-2 rounded-md border px-2.5 py-1.5 text-[12px] md:flex ${isSnapshotStale ? 'border-amber-400/20 bg-amber-400/10 text-amber-100' : 'border-emerald-400/20 bg-emerald-400/10 text-emerald-100'}`}>
          {isSnapshotStale ? <AlertTriangle className="h-3.5 w-3.5 text-amber-300" /> : <Activity className="h-3.5 w-3.5 text-emerald-300" />}
          <span className="font-medium">{isSnapshotStale ? 'DELAYED' : 'LIVE'}</span>
          <span className="hidden text-current/50 xl:inline">·</span>
          <span className="hidden xl:inline">Updated {lastUpdatedLabel}</span>
        </div>

        <div className="hidden items-center gap-3 border-l border-cyan-900/40 pl-3 text-[12px] text-cyan-200/70 xl:flex">
          <span><strong className="font-semibold text-cyan-100">{signalCount}</strong> signals</span>
          <span><strong className="font-semibold text-cyan-100">{countryCount}</strong> countries</span>
          <span><strong className="font-semibold text-cyan-100">{recentCount}</strong> fresh</span>
        </div>

        <button
          onClick={onOpenAbout}
          className="inline-flex items-center gap-1.5 rounded-md px-2.5 py-1.5 text-[12px] text-cyan-200/80 transition-colors hover:bg-cyan-500/5 hover:text-cyan-100"
        >
          <Info className="h-3.5 w-3.5" /> <span className="hidden sm:inline">About</span>
        </button>

        <div className="hidden items-center gap-1.5 rounded-md border border-cyan-400/20 bg-cyan-400/10 px-2.5 py-1.5 text-[12px] text-cyan-100/90 sm:flex">
          <Database className="h-3.5 w-3.5" /> R2
        </div>
        <div className="hidden items-center gap-1.5 rounded-md border border-cyan-900/50 bg-[#061417]/80 px-2.5 py-1.5 text-[12px] text-cyan-300/80 lg:flex">
          <Radio className="h-3.5 w-3.5" /> scheduled
        </div>
      </div>
    </header>
  );
};

export default Header;
